/* eslint-disable @typescript-eslint/camelcase */
// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Scrollchor from 'react-scrollchor'
import { Waypoint } from 'react-waypoint'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

import Indicator from 'components/indicator'

const ZuerichData = require('./data-zuerich.csv')
const BernData = require('./data-bern.csv')
const BaselData = require('./data-basel.csv')

const Zuerich = 'Zürich'
const Bern = 'Bern'
const Basel = 'Basel'

const weatherStationZuerich = 'Zürich-Fluntern'
const weatherStationBern = 'Bern-Zollikofen'
const weatherStationBasel = 'Basel-Binningen'

const ARTICLE_ID = '24477516'
const articleIDZuerich = '24477516'
const articleIDBern = '20990265'
const articleIDBasel = '26775399'

// import Lottie from 'react-lottie'

let clientData = ZuerichData
let clientTown = Zuerich
let clientWeatherStation = weatherStationZuerich
let clientID = articleIDZuerich

switch (parseHostname().publicationName) {
  case 'bazonline':
    clientData = BaselData
    clientTown = Basel
    clientWeatherStation = weatherStationBasel
    clientID = articleIDBasel
    break

  case 'derbund':
  case 'bernerzeitung':
  case 'berneroberlaender':
  case 'thunertagblatt':
  case 'langenthalertagblatt':
    clientData = BernData
    clientTown = Bern
    clientWeatherStation = weatherStationBern
    clientID = articleIDBern
    break
}

function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={clientID} additionalShares={297} />
      <ThemeSwitch />

      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <h1 className='ui header' style={{ marginBottom: 0 }}>
            So heiss wird es in {clientTown} in{' '}
            <span style={{ whiteSpace: 'nowrap' }}>40 Jahren</span>
          </h1>
          <h2 className='ui header' style={{ marginTop: 0 }}>
            <div className='small sub header'>
              Akuter Hitzestress in den Städten: Wir werfen einen Blick in die
              Klimazukunft von {clientTown} und zeigen einen wohl typischen
              Sommer in den Jahren 2060 und 2085.
            </div>
          </h2>
          <p className='ta author'>
            <strong>Von Patrick Vögeli und Marc Brupbacher</strong>
          </p>
        </div>
      </header>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical segment'>
        <div className='ui text container first'>
          <p>
            Was passiert, wenn wir weiterhin zu viele Treibhausgase produzieren?
            Unsere Übersicht mit sieben Indikatoren zeigt so konkret und
            anschaulich wie möglich die Veränderungen in der Stadt {clientTown}{' '}
            um das Jahr{' '}
            <span
              className='boxStyle2060 intro'
              style={{ whiteSpace: 'nowrap', fontSize: '.97em' }}
            >
              2060
            </span>{' '}
            und{' '}
            <span
              className='boxStyle2085 intro'
              style={{ whiteSpace: 'nowrap', fontSize: '.97em' }}
            >
              2085
            </span>{' '}
            gegenüber dem Referenzzeitraum{' '}
            <span
              className='boxStyleToday intro'
              style={{ whiteSpace: 'nowrap', fontSize: '.97em' }}
            >
              1981–2010
            </span>
            . Mit Klimaschutz (
            <i
              className='leaf icon'
              style={{ marginRight: '0.1em', marginLeft: '0.1em' }}
            />
            ) können die Auswirkungen deutlich verringert werden. Wir stützen
            uns auf die Klimaszenarien CH2018 des Bundes, die bisher den
            genauesten Blick in die Klimazukunft unseres Landes ermöglichten{' '}
            <span style={{ whiteSpace: 'nowrap' }}>
              (
              <Scrollchor to='#methodik'>
                <i
                  className='icon angle double down'
                  style={{ whiteSpace: 'nowrap' }}
                />
                Mehr zur Methodik
              </Scrollchor>
              )
            </span>
            .
          </p>
          <p>
            Alle folgenden Werte zeigen den Median. Dieser entspricht am ehesten
            dem absehbaren Wert und wird daher im Rahmen der Klimaszenarien als
            «erwartet» bezeichnet. Wenn beispielsweise für 2060 durchschnittlich
            acht Tropennächte prognostiziert werden, dann liegen die Hälfte der
            Modellresultate über respektive unter diesem Wert.
          </p>
        </div>

        <div className='ui container'>
          {/*
        <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: animationData,
                  renderer: 'canvas',
                  rendererSettings: {
                    className: 'lottiesvg'
                  }
                }}
                style={{ width: '28%', height: 'auto' ,marginTop:''}}
        /> */}

          {clientData.map((id, index) => (
            <>
              <Indicator key={id.mainTitle} {...id} />

              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === Waypoint.below) {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'Interactions',
                      event_action: 'vertical-scroll',
                      event_label: (index + 1) * 14 + 'ContentRead'
                    })
                  }
                }}
              />
            </>
          ))}
        </div>
      </div>

      <Footer
        articleId={clientID}
        starColor='yellow'
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie verständlich finden Sie die Vergleiche?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          [
            'Konzept, Programmierung und Gestaltung',
            'Patrick Vögeli und Marc Brupbacher'
          ],
          [
            'Experten-Kommentare',
            'Dr. Andreas Fischer, Leiter der neuen Klimaszenarien CH2018 beim Bundesamt für Meteorologie und Klimatologie MeteoSchweiz'
          ],
          [
            'Quelle',
            'National Centre for Climate Services: CH2018 - Klimaszenarien für die Schweiz'
          ]
        ]}
      >
        <div className='ui vertical fitted attached segment' id='methodik'>
          <div
            className='ui text container methodik'
            style={{ position: 'relative' }}
          >
            <h3>Methodik</h3>

            <p>
              Simulationen mit insgesamt 21 verschiedenen Computermodellen, die
              an Europäischen Forschungsinstitutionen betrieben werden, bilden
              die Grundlage der Klimaszenarien CH2018. Die Klimaszenarien CH2018
              berücksichtigen in Anlehnung an die Arbeiten des Weltklimarats
              IPCC (Intergovernmental Panel on Climate Change) zwei mögliche
              Entwicklungen der Treibhausgasemissionen:
            </p>
            <div className='list'>
              <ul>
                <li>
                  Konsequenter Klimaschutz: <br />
                  Mit einer umgehend eingeleiteten Senkung der Emissionen auf
                  praktisch null wird der Anstieg der Treibhausgaskonzentration
                  in der Atmosphäre bis etwa in 20 Jahren gestoppt. Damit lassen
                  sich die Ziele des Pariser Klimaabkommens von 2015
                  wahrscheinlich erreichen und die globale Erwärmung auf zwei
                  Grad Celsius gegenüber dem vorindustriellen Zustand begrenzen
                  (RCP 2.6**).
                </li>
                <br />
                <li>
                  Kein Klimaschutz: <br />
                  Klimaschutzmassnahmen werden nicht ergriffen. Trotz des
                  technischen Fortschritts nehmen daher die klimawirksamen
                  Emissionen stetig zu – und mit ihnen die Erwärmung. (RCP
                  8.5**).
                </li>
              </ul>
            </div>
            <p>
              Die Klimaszenarien CH2018 beschreiben jeweils einen Mittelwert der
              Klimaverhältnisse über einen Zeitraum von drei Jahrzehnten. Sie
              gruppieren sich um die Jahre 2060 und 2085. Wenn es im Text oben
              «2060» heisst, bezieht sich dies auf den Zeitraum von 2045 bis
              2074. Entsprechend bedeutet «2085» die Jahre von 2070 bis 2099.
            </p>
            <p>
              Natürlich werden auch in Zukunft einzelne Jahre von den erwarteten
              Durchschnittswerten abweichen. Wie wir es bereits heute kennen,
              sind in jedem Jahr einzelne Klimaphänomene schwächer oder stärker
              ausgeprägt als im langjährigen Mittel.
            </p>
            <p>
              Als gegenwärtige Norm des Schweizer Klimas gilt der Zeitraum von
              1981 bis 2010. Diese dreissig Jahre bilden den Ausgangspunkt der
              Simulationen und dienen als Referenzzeitraum für sämtliche Angaben
              über zukünftige Veränderungen gegenüber dem heutigen Klima. Dabei
              ist zu beachten, dass sich das Klima inzwischen bereits wieder
              verändert hat und die Temperaturen seit den 1980er-Jahren noch
              schneller ansteigen als zuvor. Die Werte für {clientTown} beziehen
              sich auf die Wetterstation {clientWeatherStation}.
            </p>
            <p style={{ marginBottom: '0em' }}>
              Auf der Website{' '}
              <a
                href='http://www.klimaszenarien.ch'
                style={{ whiteSpace: 'nowrap' }}
              >
                <i className='icon external alternate' />
                www.klimaszenarien.ch
              </a>{' '}
              finden Sie weiterführende Informationen und Datensätze.
            </p>
          </div>
        </div>
      </Footer>
    </div>
  )
}

export default hot(AppComponent)
